import { Capacitor, registerPlugin } from '@capacitor/core'

const MoveProSyncNative = registerPlugin('MoveProSync')

export const MOVEPRO_SYNC_STATES = Object.freeze({
    IDLE: 'idle',
    PREPARED: 'prepared',
    SYNCING: 'syncing',
    INTERRUPTED: 'interrupted',
    FINISHED: 'finished',
    UNAVAILABLE: 'unavailable',
})

export const MOVEPRO_SYNC_EVENTS = Object.freeze({
    STARTED: 'started',
    PROGRESS: 'progress',
    FILE_COMPLETED: 'fileCompleted',
    INTERRUPTED: 'interrupted',
    FINISHED: 'finished',
})

const normalizeFile = (file = {}) => ({
    ...file,
    fileKey: file.fileKey || file.filename || '',
    filename: file.filename || '',
    index: Number(file.index ?? -1),
    startPage: Number(file.startPage ?? -1),
    numberOfPages: Number(file.numberOfPages ?? 0),
    size: Number(file.size ?? 0),
    uuid: file.uuid || '',
})

const fallbackState = () => ({
    state: MOVEPRO_SYNC_STATES.UNAVAILABLE,
    currentFileIndex: -1,
    completedFilesCount: 0,
    lastError: null,
})

const isAvailable = () => Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('MoveProSync')

const startSync = async ({ runId = null, deviceId = null, files = [] } = {}) => {
    if (!isAvailable()) {
        return fallbackState()
    }

    return await MoveProSyncNative.startSync({
        runId,
        deviceId,
        files: files.map(normalizeFile),
    })
}

const getState = async () => {
    if (!isAvailable()) {
        return fallbackState()
    }

    return await MoveProSyncNative.getState()
}

const drainCompletedFiles = async () => {
    if (!isAvailable()) {
        return { files: [] }
    }

    return await MoveProSyncNative.drainCompletedFiles()
}

const stopSync = async () => {
    if (!isAvailable()) {
        return fallbackState()
    }

    return await MoveProSyncNative.stopSync()
}

const addListener = (eventName, listener) => MoveProSyncNative.addListener(eventName, listener)

export default {
    isAvailable,
    startSync,
    getState,
    drainCompletedFiles,
    stopSync,
    addListener,
}
